import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortCut'
})
export class SortCutPipe implements PipeTransform {

  transform(value: Array<any>): any {
    console.log(value);
    if(value == null) {
      return null;
    }
    return [...value].sort((a, b) => {
      const first = a.cutDate?a.cutDate:'';
      const second = b.cutDate?b.cutDate:'';
      return second.localeCompare(first);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/pipes/sort-cut-pipe.ts